import { BrilliantState } from '../models/BrilliantState';
import store from '../../store/store';

/**
 * Get the current state of brilliant
 * @returns The current state
 */
export function getState(): BrilliantState {
    const { uiState, productComparisonState, featureState } = store.getState();
    const openedStates = ['chat', 'full', 'menu'] as (typeof uiState.mode)[];
    return {
        comparingProductIds: [...productComparisonState.selectedProductIds],
        isComparing:
            featureState.mainFeatureItem?.featureType === 'product-comparison',
        isOpened: openedStates.includes(uiState.mode),
        isInitialized: true
    };
}
